import DesignTokens from '@tableau/design-tokens';
import { TabStyles } from '@tableau/widgets';

import { CommonStyles } from '~src/commonInfra/styles/CommonStyles';
import { applyColor }from '~src/style/ColorService';

export const expandoStyle: React.CSSProperties = {
    marginLeft: CommonStyles.Sizes.DefaultSpace,
    marginTop: CommonStyles.Sizes.SmallSpace
};

export const expandoStyle2: React.CSSProperties = {
    marginLeft: CommonStyles.Sizes.DefaultSpace,
    marginBottom: CommonStyles.Sizes.MediumSpace
};

export const authDropdownStyle: React.CSSProperties = {
    maxWidth: 300,
    marginBottom: CommonStyles.Sizes.MediumSpace,
};

export const settingsContainer: React.CSSProperties = {
    maxWidth: 500
};

export const authenticationDataGridStyle: React.CSSProperties = {
    overflow: 'hidden',
    padding: '0px',
    marginTop: `${CommonStyles.Sizes.LineHeight}px`,
    zIndex: 'auto',
};

export const authenticationDataGridEmptyStyle: React.CSSProperties = {
    marginBottom: CommonStyles.Sizes.MediumSpace,
};

export const newConfigurationHeaderText: React.CSSProperties = {
    fontWeight: 'normal',
    fontSize: TabStyles.Typography.Sizing.XXLarge,
    marginRight: TabStyles.Spacing.ExtraLargeSpace,
    marginBottom: CommonStyles.Sizes.LargeSpace,
};

export const backButtonSectionStyle: React.CSSProperties = {
    display: 'flex',
    marginBottom: CommonStyles.Sizes.LargeSpace,
    paddingTop: 15,
    alignItems: 'center',
};

export const backButtonTextStyle: React.CSSProperties = {
    backgroundColor: 'transparent',
    color: applyColor(DesignTokens.color.link.inline.default.active, CommonStyles.Colors.HyperlinkBlue),
    border: 'none',
    cursor: 'pointer',
    outline: 'inherit',
};

export const newConfigurationContainer: React.CSSProperties = {
    marginLeft: CommonStyles.Sizes.LargeSpace,
    overflow: 'visible',
};

export const textFieldContainer: React.CSSProperties = {
    marginBottom: CommonStyles.Sizes.LargeSpace,
    width: 390
};

export const multipleIdPSettings: React.CSSProperties = {
    marginBottom: CommonStyles.Sizes.LargeSpace,
};

export const MaxConfigurationsReachedDialogueStyle: React.CSSProperties = {
    width: 'auto',
    height: 'auto',
    paddingTop: CommonStyles.Sizes.MediumSpace,
    paddingLeft: CommonStyles.Sizes.MediumSpace,
    paddingRight: CommonStyles.Sizes.MediumSpace
};

export const MaxConfigurationsReachedTitleStyle: React.CSSProperties = {
    font: 'Benton Sans/Core/title 2',
    fontSize: 16,
    lineHeight: '24px',
    paddingBottom: CommonStyles.Sizes.MediumSpace,

};

export const MaxConfigurationsCloseButton: React.CSSProperties = {
    whiteSpace: 'nowrap',
    textAlign: 'right'
};